import {
    GET_SHIPSTATUS_REQUEST, GET_SHIPSTATUS_ERROR, GET_SHIPSTATUS_SUCCESS, ADD_SHIPSTATUS_SUCCESS, ADD_SHIPSTATUS_REQUEST, ADD_SHIPSTATUS_ERROR, UPDATE_SHIPSTATUS_REQUEST,
    UPDATE_SHIPSTATUS_ERROR, UPDATE_SHIPSTATUS_SUCCESS, DELETE_SHIPSTATUS_REQUEST, DELETE_SHIPSTATUS_ERROR, DELETE_SHIPSTATUS_SUCCESS
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_SHIPSTATUS_REQUEST:
            return {
                loading: true,
            };
        case GET_SHIPSTATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_SHIPSTATUS_ERROR:
            return {
                ...state,
                loading: false
            };
        case ADD_SHIPSTATUS_REQUEST:
            return {
                loading: true,
            };
        case ADD_SHIPSTATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case ADD_SHIPSTATUS_ERROR:
            return {
                ...state,
                loading: false
            };
        case DELETE_SHIPSTATUS_REQUEST:
            return {
                loading: true,
            };
        case DELETE_SHIPSTATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case DELETE_SHIPSTATUS_ERROR:
            return {
                ...state,
                loading: false
            };
        case UPDATE_SHIPSTATUS_REQUEST:
            return {
                loading: true,
            };
        case UPDATE_SHIPSTATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case UPDATE_SHIPSTATUS_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
}